<template>
  <v-dialog :value="value" @input="$emit('input', arguments[0])" max-width="500px">
    <v-card>
      <v-card-title>
        {{deleteMode ? 'Reconfim sign in' : (signUp ? 'Sign Up' : 'Login')}}
      </v-card-title>
      <v-container>
        <v-row v-if="signUp">
          <v-col cols="12">
            <v-text-field label="email" v-model="credentials.email" :rules="[rules.email]"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field label="list name" v-model="credentials.username"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="password"
              v-model="credentials.password"
              :rules="[rules.weak]"
              type="password"
            />
          </v-col>
        </v-row>
        <v-row v-if="signUp">
          <v-col cols="12">
            <v-text-field
              label="Confirm Password"
              v-model="passConfim"
              :rules="[match]"
              type="password"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <v-btn @click="login" color="success">{{signUp ? 'Sign Up' : 'Login'}}</v-btn>
          </v-col>
          <v-col cols="3">
            <v-btn @click="$emit('input', false)" color="error">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    passConfim: '',
    credentials: {
      email: '',
      username: '',
      password: '',
    },
    rules: {
      weak: v => v.length >= 6 || 'Password must be at least 6 characters',
      email: v => !!v.match(/.+@.+\..+/g) || 'Must be a vaild email',
    },
  }),

  props: {
    signUp: Boolean,
    value: Boolean,
    deleteMode: Boolean,
  },

  methods: {
    login() {
      this.$emit('login', { ...this.credentials, signUp: this.signUp, deleteMode: this.deleteMode });
      this.$emit('input', false);
    },

    match() {
      return this.credentials.password === this.passConfim || 'Passwords must match';
    },
  },

  watch: {
    signUp() {
      this.credentials = {
        email: '',
        username: '',
        password: '',
      };
    },
  },
};
</script>
